import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import './mainProfile.css'
import { EditProfile as EditProfileIcon, SampleUser, UpgradePremium } from '../../assests/ExportImageIcon'
import { logout as logoutAction } from '../../redux/auth/authSlice'
import { getDeviceDetails } from '../../utils/device'
import Modal from '../../componants/modal/Modal'
import ProfileSidebar from './profileSidebar'
import Mytrips from './mytrip/mytrips'
import MyEvents from './myEvents/myEvents'
import MyVenues from './myVenues/myVenues'
import MyRfps from './myRfps/myRfps'
import MyGroups from './groups/myGroups'
import CreateGroup from './groups/createGroup'
import GroupDetail from './groups/groupDetail'
import AddExpense from './groups/addExpense'
import ExpenseDetail from './groups/expenseDetail'
import MyWallet from './mywallet/myWallet'
import PrivacySecurity from './privacySecurity/privacySecurity'
import Setting from './privacySecurity/setting'
import MySubscription from './privacySecurity/mySubscription'
import KycDocument from './privacySecurity/kycDocument'
import DataPrivacy from './privacySecurity/dataPrivacy'
import Language from './privacySecurity/language'
import Currency from './privacySecurity/currency'
import TermsService from './privacySecurity/termsService'
import PrivacyPolicy from './privacySecurity/privacyPolicy'
import ManageSubscription from './privacySecurity/manageSubscription'
import SubscriptionPayment from './privacySecurity/subscriptionPayment'
import HelpSupport from './privacySecurity/helpSupport'
import EditProfile from './editProfile'
import ReviewRating from './reviewRating/reviewRating'
import service from '../../services/service'
import endpoints from '../../services/endpoints'
import { updateUser } from '../../redux/auth/authSlice'
import { resolveProfileImage, withProfileImage } from '../../utils/profileImage'

const PROFILE_STATS = [
  { value: '12', label: 'Bookings' },
  { value: '5', label: 'Wishlist' },
  { value: '-', label: 'Rewards' },
]

const MainProfile = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const refreshToken = useSelector((state) => state.auth.refresh_token)
  // Lets callers deep-link into a specific tab, e.g. navigate('/profile', { state: { section: 'trips' } })
  // or /profile?section=rfps from Sabraah.
  const [activeSection, setActiveSection] = useState(
    location.state?.section || searchParams.get('section') || 'profile'
  )
  // The initializer above only runs on first mount — a caller already ON
  // /profile (e.g. My Trips' "Rate" button navigating to itself with new
  // state) doesn't remount this component, so react to state changes too.
  useEffect(() => {
    if (location.state?.section) setActiveSection(location.state.section)
  }, [location.state])
    const [selectedPlan, setSelectedPlan] = useState(null)
  const [selectedGroupId, setSelectedGroupId] = useState(null)
  const [selectedExpenseId, setSelectedExpenseId] = useState(null)
  const [editOpen, setEditOpen] = useState(false)
  const [profilePicPreview, setProfilePicPreview] = useState('')
  const [account, setAccount] = useState(null)
  const [loggingOut, setLoggingOut] = useState(false)
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false)

  const fullName = useMemo(() => {
    const value = `${account?.first_name || ''} ${account?.last_name || ''}`.trim()
    return value || 'User'
  }, [account?.first_name, account?.last_name])

  useEffect(() => {
    service.get(endpoints.users.userAccount, {}, { silent: true }).then(({ data }) => {
      const nextAccount = data?.data || {}
      const patched = withProfileImage(nextAccount)
      const imageUrl = patched.profileImageUrl || resolveProfileImage(patched)
      setAccount(patched)
      setProfilePicPreview(imageUrl)
      // Same image source for header avatar
      dispatch(updateUser(patched))
    })
  }, [dispatch])

  const handleLogout = async () => {
    if (loggingOut) return
    setLoggingOut(true)
    try {
      await service.post(endpoints.users.logout, {
        refresh: refreshToken,
        device_id: getDeviceDetails().device_id,
      })
    } catch {
      // Log the user out locally regardless of API failure (expired
      // token, offline, etc.) — staying "logged in" on a dead session
      // is worse than a failed logout call the backend never sees.
    } finally {
      dispatch(logoutAction())
      navigate('/')
    }
  }

  const handleProfileSaved = (nextAccount) => {
    const patched = withProfileImage(nextAccount, profilePicPreview)
    const imageUrl = patched.profileImageUrl || resolveProfileImage(patched) || profilePicPreview
    setAccount(patched)
    setProfilePicPreview(imageUrl)
    // Keep header avatar in sync after Edit Profile save
    dispatch(updateUser(patched))
  }

  return (
    <>
      <section className='myProfileMain commonTopPadding commonBottomPadding'>
        <div className='container'>
          <div className='row g-4'>
            <div className='col-md-12'>
              <div className='upgradePremium paddingCommon20 borderRadius20'>
                <div className='upgradePremium__left'>
                  <span className='upgradePremium__icon'><img src={UpgradePremium} alt="" /></span>
                  <div>
                    <div className='upgradePremium__title'>Upgrade to Premium</div>
                    <div className='upgradePremium__subtitle'>Unlock unlimited AI features, priority support, and exclusive discounts</div>
                  </div>
                </div>
                <button type='button' className='commonBtn upgradePremium__btn'>View Plans @399</button>
              </div>
            </div>
            <div className='col-md-12'>
              <div className='profileBox'>
                <ProfileSidebar
                  activeSection={
                    ['change-password', 'kyc-document', 'data-privacy'].includes(activeSection) ? 'privacy'
                      : ['language', 'currency', 'terms-service', 'privacy-policy'].includes(activeSection) ? 'settings'
                        : ['manage-subscription', 'subscription-payment'].includes(activeSection) ? 'subscription'
                          : ['create-group', 'group-detail', 'add-expense', 'expense-detail'].includes(activeSection) ? 'groups'
                            : activeSection
                  }
                  onSelect={setActiveSection}
                  onEditProfile={() => setEditOpen(true)}
                  onLogout={() => setLogoutConfirmOpen(true)}
                  loggingOut={loggingOut}
                  name={fullName}
                  email={account?.email || ''}
                  avatarUrl={profilePicPreview}
                />
                <div className='profileData'>
                  {activeSection === 'trips' ? (
                    <Mytrips />
                  ) : activeSection === 'groups' ? (
                    <MyGroups
                      onCreateGroup={() => setActiveSection('create-group')}
                      onOpenGroup={(groupId) => {
                        setSelectedGroupId(groupId)
                        setActiveSection('group-detail')
                      }}
                    />
                  ) : activeSection === 'create-group' ? (
                    <CreateGroup
                      onBack={() => setActiveSection('groups')}
                      onCreated={() => setActiveSection('groups')}
                    />
                  ) : activeSection === 'group-detail' ? (
                    <GroupDetail
                      groupId={selectedGroupId}
                      onBack={() => setActiveSection('groups')}
                      onAddExpense={() => setActiveSection('add-expense')}
                      onOpenExpense={(expenseId) => {
                        setSelectedExpenseId(expenseId)
                        setActiveSection('expense-detail')
                      }}
                    />
                  ) : activeSection === 'add-expense' ? (
                    <AddExpense
                      groupId={selectedGroupId}
                      onBack={() => setActiveSection('group-detail')}
                    />
                  ) : activeSection === 'expense-detail' ? (
                    <ExpenseDetail
                      expenseId={selectedExpenseId}
                      onBack={() => setActiveSection('group-detail')}
                    />
                  ) : activeSection === 'events' ? (
                    <MyEvents />
                  ) : activeSection === 'venues' ? (
                    <MyVenues />
                  ) : activeSection === 'rfps' ? (
                    <MyRfps />
                  ) : activeSection === 'wallet' ? (
                    <MyWallet />
                  ) : activeSection === 'privacy' ? (
                    <PrivacySecurity onNavigate={setActiveSection} />
                  ) : activeSection === 'kyc-document' ? (
                    <KycDocument onBack={() => setActiveSection('privacy')} />
                  ) : activeSection === 'data-privacy' ? (
                    <DataPrivacy onBack={() => setActiveSection('privacy')} />
                  ) : activeSection === 'settings' ? (
                    <Setting onSelect={setActiveSection} />
                  ) : activeSection === 'language' ? (
                    <Language onBack={() => setActiveSection('settings')} />
                  ) : activeSection === 'currency' ? (
                    <Currency onBack={() => setActiveSection('settings')} />
                  ) : activeSection === 'terms-service' ? (
                    <TermsService onBack={() => setActiveSection('settings')} />
                  ) : activeSection === 'privacy-policy' ? (
                    <PrivacyPolicy onBack={() => setActiveSection('settings')} />
                  ) : activeSection === 'subscription' ? (
                    <MySubscription
                      onManage={() => setActiveSection('manage-subscription')}
                      onUpgrade={(selection) => {
                        setSelectedPlan(selection)
                        setActiveSection('subscription-payment')
                      }}
                    />
                  ) : activeSection === 'manage-subscription' ? (
                    <ManageSubscription onBack={() => setActiveSection('subscription')} />
                  ) : activeSection === 'subscription-payment' ? (
                    <SubscriptionPayment
                      selection={selectedPlan}
                      onBack={() => setActiveSection('subscription')}
                      onSuccess={() => setActiveSection('subscription')}
                    />
                  ) : activeSection === 'help-support' ? (
                    <HelpSupport />
                  ) : activeSection === 'rating-reviews' ? (
                    <ReviewRating />
                  ) : (
                    <div className='profileContent bgWhite commonBorder borderRadius20 paddingCommon20'>
                      <div className='profileContent__head'>
                        <div className='profileContent__user'>
                          <span className='profileContent__avatarWrap'>
                            <img
                              src={profilePicPreview || SampleUser}
                              alt=""
                              className='profileContent__avatar'
                              onError={(e) => {
                                if (e.currentTarget.src !== SampleUser) e.currentTarget.src = SampleUser
                              }}
                            />
                            <span
                              className='profileContent__editBadge'
                              role='button'
                              tabIndex={0}
                              onClick={() => setEditOpen(true)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') setEditOpen(true)
                              }}
                            >
                              <img src={EditProfileIcon} alt="" />
                            </span>
                          </span>
                          <div>
                            <div className='profileContent__nameRow'>
                              <span className='profileContent__name'>{fullName}</span>
                              <span className='profileContent__badge'>Influencer</span>
                            </div>
                            <div className='profileUser__email'>{account?.email || '—'}</div>
                          </div>
                        </div>
                        <div className='profileContent__actions'>
                          <button type='button' className='profileContent__aiBtn'>Generate AI Avatar</button>
                          <button type='button' className='travellerAddBtn profileContent__libraryBtn'>Choose from Liabrary</button>
                        </div>
                      </div>

                      <div className='bsFareDivider mt-3 mb-3' />

                      <div className='profileStats'>
                        {PROFILE_STATS.map((stat, index) => (
                          <div className={`profileStats__item ${index < PROFILE_STATS.length - 1 ? 'cmnBdr' : ''}`} key={stat.label}>
                            <div className='profileStats__value'>{stat.value}</div>
                            <div className='profileStats__label'>{stat.label}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <EditProfile
        open={editOpen}
        onClose={() => setEditOpen(false)}
        initialData={account}
        profilePicUrl={profilePicPreview}
        onSaved={handleProfileSaved}
      />

      <Modal open={logoutConfirmOpen} onClose={() => setLogoutConfirmOpen(false)} maxWidth={380}>
        <div className='logoutConfirm'>
          <div className='logoutConfirm__title'>Log out?</div>
          <p className='logoutConfirm__desc'>Are you sure you want to log out of your account?</p>
          <div className='logoutConfirm__actions'>
            <button
              type='button'
              className='commonBtnTransparent'
              onClick={() => setLogoutConfirmOpen(false)}
              disabled={loggingOut}
            >
              Cancel
            </button>
            <button
              type='button'
              className='commonBtn'
              onClick={() => {
                setLogoutConfirmOpen(false)
                handleLogout()
              }}
              disabled={loggingOut}
            >
              {loggingOut ? 'Logging out...' : 'Logout'}
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default MainProfile
